import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Textarea from '../component/Textarea'
import TicketingCart from '../component/TicketingCart'
import MainLayout from '../mainLayout'
import TextField from './../component/TextField'
import Slider from "react-slick";
import Select from 'react-select';
//moment import
import moment from "moment-timezone";
//  Date Picker
import DatePicker from "react-datepicker";
import CalendarIcon from '../icons/calendaricon'
import DropdownMaster from '../component/DropdownMaster'
import CheckBox from '../component/CheckBox'
import UploadFile from '../component/UploadFile'
import VideoOnly from '../icons/VideoOnly'
import ImageText from '../icons/ImageText'
import TextOnlyIcon from '../icons/TextOnly'
// editor
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//Service import
import service from '../services'
import ErrorPopUp from '../component/errorPopUp'
import ModalMessage from '../component/ModalMessage'

//page
import Carousal from '../pages/carousal'
import RsvpForm from '../pages/RsvpForm'
import WebsiteLogos from '../component/WebsiteLogos'
import PlusIcon from '../icons/plusicon'
import { scheduled } from 'rxjs'
import Loader from '../component/loader'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'

let sub;
export default class Home extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errorPopup: false,
            errorMsg: '',
            loaderFlag: false,
            messageModal: false,
            id: '',
            headerSubtitle: EditorState.createEmpty(),
            shortFlim: false,
            activetab: 0,
            countdownDateTime: new Date(),
            updatedAt: moment.utc().subtract(360, 'minutes'),
            updatedBy: {},
            countdownText: "",
            hours: { value: '7', label: '7' },
            mins: { value: '30', label: '30' },
            stamps: { value: 'AM', label: 'AM' },
            positions: ["Top", "Bottom", "Right", "Left"],
            data: [
                {
                    "label": "Site Settings",
                    "Content": "",
                },
                {
                    "label": "Website Logos",
                    "Content": "",
                },
                {
                    "label": "RSVP Form",
                    "Content": "",
                },
                // {
                //     "label": "Header & Footer",
                //     "Content": "",
                // },
                // {
                //     "label": "carousel",
                //     "Content": "",
                // }
            ],
            sliderData: [],
            textony: [],
            nav1: null,
            nav2: null,
            styles: [],
            locationType: [
                { _id: '1', name: 'In-Person' },
                { _id: '2', name: 'Online' },
            ],
            scheduledView: [
                { _id: '1', name: 'Calendar View' },
                { _id: '2', name: 'List View' },
            ],
            siteSettingsSection: 'myFavorites',
            siteSettingsSections: [
                { _id: 'myFavorites', name: 'My Favorites Page' },
                { _id: 'mySchedule', name: 'My Schedule Page' },
                { _id: 'myViewingRoom', name: 'My ViewingRoom Page' },
                { _id: 'myWaitlist', name: 'My Waitlist Page' },
                { _id: 'loginPopup', name: 'Login Popup' },
                { _id: 'preSale', name: 'PreSale' },
                { _id: 'paf', name: 'PAF' },
            ],
            hideWhenNoScreenings:false,
            hideRecommendations:false,
            isHomeEdited: false
        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                urlValidation: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
            }
        });
        this.apiserve = new service();
        this.rsvpFormRef = React.createRef();
    }

    getCurrentFormData = () => {
        const normalizeDraftHtml = (editorState) => {
            if (!editorState || typeof editorState === 'string') return '';
            const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
            return (html === '<p></p>\n' || html === '<p></p>') ? '' : html;
        };

        return cloneDeep({
            headerTitle: this.state.headerTitle,
            headerSubtitle: normalizeDraftHtml(this.state.editorState),
            CTATitle: this.state.CTATitle,
            CTAUrl: this.state.CTAUrl,
            countdownDateTime: this.state.countdownDateTime,
            hours: this.state.hours,
            mins: this.state.mins,
            stamps: this.state.stamps,
            countdownText: this.state.countdownText,
            myFestivalPagesText: normalizeDraftHtml(this.state.editorStateFestival),
            myWaitListBannerText: normalizeDraftHtml(this.state.myWaitListBannerText),
            myScheduleBannerText: normalizeDraftHtml(this.state.myScheduleBannerText),
            myViewingRoomHeaderText: normalizeDraftHtml(this.state.myViewingRoomHeaderText),
            myViewingRoomBannerText: normalizeDraftHtml(this.state.myViewingRoomBannerText),
            fpgLoginMessage: normalizeDraftHtml(this.state.fpgLoginMessage),
            sioEnableBannerText: normalizeDraftHtml(this.state.sioEnableBannerText),
            sioDisableBannerText: normalizeDraftHtml(this.state.sioDisableBannerText),
            pafBannerText: normalizeDraftHtml(this.state.pafBannerText),
            defaultScreeningType: this.state.defaultScreeningType,
            hideWhenNoScreenings: this.state.hideWhenNoScreenings,
            hideRecommendations: this.state.hideRecommendations,
            defaultScheduleView: this.state.defaultScheduleView,
        });
    }

    markHomeEdited = () => {
        if (this.state.id && this.state.initialData) {
            const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
            if (this.state.isHomeEdited !== isDirty) {
                this.setState({ isHomeEdited: isDirty });
            }
        }
    }

    updateState = (data) => {
        this.setState(data, () => this.markHomeEdited());
    }
    TabClick = (index) => {
        this.setState({
            activetab: index
        })
    }
    getHeaderPage = () => {
        this.apiserve.sendevent("homePage|HeaderAndFooter|getList", {})
    }
    componentWillMount = () => {
        this.getHeaderPage()
        this.apiserve.sendevent("homePage|carousal|getList", {})
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "homePage|HeaderAndFooter|getList":
                    if (!response.error) {
                        if (response.data.docs.length !== 0) {
                            let homeFields = ['headerSubtitle','myFestivalPagesText', 'myScheduleBannerText','myWaitListBannerText','myViewingRoomHeaderText','myViewingRoomBannerText','fpgLoginMessage',"sioDisableBannerText","sioEnableBannerText","pafBannerText"]
                            homeFields.map((itemData) => {
                                const blocksFromHtml = htmlToDraft(response.data.docs[0]?.[itemData]);
                                const { contentBlocks, entityMap } = blocksFromHtml;
                                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                                const editorState = EditorState.createWithContent(contentState);
                                this.setState({[itemData === 'headerSubtitle' ? 'editorState' : itemData === 'myFestivalPagesText' ? 'editorStateFestival' : [itemData]]:editorState})
                            })

                            const year = moment(response.data.docs[0].countdownDateTime).tz("US/Mountain").format('YYYY')
                            const month = moment(response.data.docs[0].countdownDateTime).tz("US/Mountain").format('MM') - 1
                            const date = moment(response.data.docs[0].countdownDateTime).tz("US/Mountain").format('DD') 
                            var countdownDateTime = new Date(year, month, date)
                            // var hours =  new Date(new Date(response.data.docs[0].countdownDateTime).setHours(new Date(response.data.docs[0].countdownDateTime).getHours() + 1)).getHours()
                            // debugger
                            var hours = moment(response.data.docs[0].countdownDateTime).tz("US/Mountain").format('H');
                            var mins = moment(response.data.docs[0].countdownDateTime).tz("US/Mountain").format('mm');
                            var stamps = moment(response.data.docs[0].countdownDateTime).tz("US/Mountain").format('A');
                            
                            this.setState({
                                id: response.data.docs[0]._id,
                                loaderFlag: false,
                                headerTitle: response.data.docs[0].headerTitle,
                                CTATitle: response.data.docs[0].CTATitle,
                                CTAUrl: response.data.docs[0].CTAUrl,
                                countdownDateTime: new Date(year, month, date),
                                hours: { value: hours, label: hours },
                                mins: { value: mins, label: mins },
                                stamps: { value: stamps, label: stamps },
                                countdownText: response.data.docs[0].countdownText,
                                updatedAt: moment.tz(response.data.docs[0].updatedAt, 'US/Mountain'),
                                updatedBy: response.data.docs[0].updatedBy,
                                defaultScreeningType: response.data.docs[0].defaultScreeningType,
                                hideWhenNoScreenings: response.data.docs[0].hideWhenNoScreenings,
                                hideRecommendations: response.data.docs[0].hideRecommendations,
                                defaultScheduleView: response.data.docs[0].defaultScheduleView,
                                isHomeEdited: false
                            }, () => {
                                this.setState({ initialData: this.getCurrentFormData(), isHomeEdited: false });
                            })
                        }
                        // this.apiserve.success('Update Successfully.')
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error
                        })
                    }
                    break;
            }
        })
    }
    componentWillUnmount = () => {
        sub.unsubscribe();
    }
    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2
        });
        sub = this.apiserve.getevent().subscribe((response) => {

            switch (response.event) {
                case "homePage|HeaderAndFooter|create":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            isHomeEdited: false
                        })
                        this.apiserve.success('Create Successfully.')
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error
                        })
                    }
                    break;
            }
            switch (response.event) {
                case "homePage|HeaderAndFooter|edit":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false, updatedAt: moment.tz(moment(), 'US/Mountain'),
                            isHomeEdited: false
                        })
                        this.getHeaderPage()
                        this.apiserve.success('Update Successfully.')
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error
                        })
                    }
                    break;
            }
        })
    }
    handleTimeHours = (e) => {
        this.updateState({
            hours: e
        })
    }
    handleTimeMins = (e) => {
        this.updateState({
            mins: e,
        })
    }
    handleTimeStamps = (e) => {
        this.updateState({
            stamps: e,
        })
    }
    handleChange = (e) => {
       
        this.updateState({
            countdownDateTime:e
        });
    }
    Onchange = (e, id) => {
        const { name, checked, value } = e.target;
        let sliderDataList = [...this.state.sliderData]
        sliderDataList.forEach(element => {
            if (element._id === id) {
                element.value = checked
                element.styleType = value
            }
        });
        this.updateState({
            ...this.state,
            sliderData: sliderDataList,
        })
    }
    onInputChange = (e) => {
        this.updateState({
            [e.target.name]: e.target.value
        });
    }
    onEditorStateChange = (editorState) => {
        this.updateState({
            editorState,
        });
    };
    onEditorStateFestivalChange = (editorStateFestival) => {
        this.updateState({
            editorStateFestival,
        })
    }
    onEditorStateChangeWaitlist = (myWaitListBannerText) => {
        this.updateState({
            myWaitListBannerText,
        });
    };
    onEditorStateChangeFpgLoginMessage = (fpgLoginMessage) => {
        this.updateState({
            fpgLoginMessage,
        });
    };
    onEditorStateChangeSioEnableBannerText = (sioEnableBannerText) => {
        this.updateState({
            sioEnableBannerText,
        });
    };
    onEditorStateChangeSioDisableBannerText = (sioDisableBannerText) => {
        this.updateState({
            sioDisableBannerText,
        });
    };
    onEditorStateChangePafBannerText = (pafBannerText) => {
        this.updateState({
            pafBannerText,
        });
    };
    onEditorStateScheduleChange = (myScheduleBannerText) => {
        this.updateState({
            myScheduleBannerText,
        })
    }
    onEditorStateChangeViewingRoom = (myViewingRoomHeaderText) => {
        this.updateState({
            myViewingRoomHeaderText,
        });
    };
    onEditorStateChangeViewingRoomBanner = (myViewingRoomBannerText) => {
        this.updateState({
            myViewingRoomBannerText,
        });
    };
    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }
    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
        })
    }

    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }

    dropChangeScreeningType = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: value
        })
    }

    submitFilm = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({loaderFlag:true})
            const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
            const markup = draftToHtml(name);
            const festivaltext = this.state.editorStateFestival ? convertToRaw(this.state.editorStateFestival.getCurrentContent()) : ''
            const markupFest = draftToHtml(festivaltext);
            const nameWaitlistBannerText = this.state.myWaitListBannerText ? convertToRaw(this.state.myWaitListBannerText.getCurrentContent()) : ''
            const markupWaitlist = draftToHtml(nameWaitlistBannerText);
            const nameFpgLoginMessage = this.state.fpgLoginMessage ? convertToRaw(this.state.fpgLoginMessage.getCurrentContent()) : ''
            const markupFpgLoginMessage = draftToHtml(nameFpgLoginMessage);
            const nameSioEnableBannerText = this.state.sioEnableBannerText ? convertToRaw(this.state.sioEnableBannerText.getCurrentContent()) : ''
            const markupSioEnableBannerText = draftToHtml(nameSioEnableBannerText);
            const nameSioDisableBannerText = this.state.sioDisableBannerText ? convertToRaw(this.state.sioDisableBannerText.getCurrentContent()) : ''
            const markupSioDisableBannerText = draftToHtml(nameSioDisableBannerText);
            const namePafBannerText = this.state.pafBannerText ? convertToRaw(this.state.pafBannerText.getCurrentContent()) : ''
            const markupPafBannerText = draftToHtml(namePafBannerText);
            const nameScheduleBanner = this.state.myScheduleBannerText ? convertToRaw(this.state.myScheduleBannerText.getCurrentContent()) : ''
            const markupScheduleBanner = draftToHtml(nameScheduleBanner);
            const nameViewingRoom = this.state.myViewingRoomHeaderText ? convertToRaw(this.state.myViewingRoomHeaderText.getCurrentContent()) : ''
            const markupViewingRoom = draftToHtml(nameViewingRoom);
            const nameViewingRoomBanner = this.state.myViewingRoomBannerText ? convertToRaw(this.state.myViewingRoomBannerText.getCurrentContent()) : ''
            const markupViewingRoomBanner = draftToHtml(nameViewingRoomBanner);
            var countDownDateFinal = new Date(this.state.countdownDateTime);

            countDownDateFinal.setHours(this.state.stamps.value === 'PM' || this.state.stamps.value === 'pm' ? parseInt(this.state.hours.value) === 12 ? parseInt(this.state.hours.value) : parseInt(this.state.hours.value) + 12 : parseInt(this.state.hours.value) === 12 ? parseInt(this.state.hours.value) - 12 : parseInt(this.state.hours.value), this.state.mins.value);

            if (this.state.id) {

                let updateHeader = {
                    id: this.state.id,
                    headerTitle: this.state.headerTitle,
                    headerSubtitle: markup,
                    CTATitle: this.state.CTATitle,
                    CTAUrl: this.state.CTAUrl,
                    countdownDateTime: this.getMtTime(countDownDateFinal),
                    countdownText: this.state.countdownText,
                    myFestivalPagesText: markupFest,
                    myWaitListBannerText:markupWaitlist,
                    myScheduleBannerText:markupScheduleBanner,
                    myViewingRoomHeaderText:markupViewingRoom,
                    myViewingRoomBannerText:markupViewingRoomBanner,
                    fpgLoginMessage:markupFpgLoginMessage,
                    sioEnableBannerText:markupSioEnableBannerText,
                    sioDisableBannerText:markupSioDisableBannerText,
                    pafBannerText:markupPafBannerText,
                    defaultScreeningType:this.state.defaultScreeningType,
                    hideWhenNoScreenings:this.state.hideWhenNoScreenings,
                    hideRecommendations:this.state.hideRecommendations,
                    defaultScheduleView:this.state.defaultScheduleView,
                }
                this.apiserve.sendevent("homePage|HeaderAndFooter|edit", updateHeader)
                
            } else {
                
                let addCreateHeader = {
                    headerTitle: this.state.headerTitle,
                    headerSubtitle: markup,
                    CTATitle: this.state.CTATitle,
                    CTAUrl: this.state.CTAUrl,
                    countdownDateTime: this.getMtTime(countDownDateFinal),
                    countdownText: this.state.countdownText,
                    myFestivalPagesText: markupFest,
                    myWaitListBannerText:markupWaitlist,
                    myScheduleBannerText:markupScheduleBanner,
                    myViewingRoomHeaderText:markupViewingRoom,
                    myViewingRoomBannerText:markupViewingRoomBanner,
                    fpgLoginMessage:markupFpgLoginMessage,
                    sioEnableBannerText:markupSioEnableBannerText,
                    sioDisableBannerText:markupSioDisableBannerText,
                    pafBannerText:markupPafBannerText,
                    defaultScreeningType:this.state.defaultScreeningType,
                    hideWhenNoScreenings:this.state.hideWhenNoScreenings,
                    hideRecommendations:this.state.hideRecommendations,
                    defaultScheduleView:this.state.defaultScheduleView,
                }
                this.apiserve.sendevent("homePage|HeaderAndFooter|create", addCreateHeader)
            }
        }
        else {
            this.setState({
                messageModal: true,
                loaderFlag: false,
            })
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    previewRecordTalk = (e) => {
        e.preventDefault()
        const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
        const markup = draftToHtml(name);
        var countDownDateFinal = new Date(this.state.countdownDateTime);

        countDownDateFinal.setHours(this.state.stamps.value === 'PM' || this.state.stamps.value === 'pm' ? parseInt(this.state.hours.value) === 12 ? parseInt(this.state.hours.value) : parseInt(this.state.hours.value) + 12 : parseInt(this.state.hours.value) === 12 ? parseInt(this.state.hours.value) - 12 : parseInt(this.state.hours.value), this.state.mins.value);
        let Header = {}

        if (this.state.id) {
            Header = {
                id: this.state.id,
                key: 'header-footer',
                headerTitle: this.state.headerTitle,
                headerSubtitle: markup,
                CTATitle: this.state.CTATitle,
                CTAUrl: this.state.CTAUrl,
                countdownDateTime: this.getMtTime(countDownDateFinal),
                countdownText: this.state.countdownText
            }
        }
        let HeaderEvents = this.apiserve.encrypt(Header)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_PREVIEW + 'home-preivew?data=' + HeaderEvents);
    }
    render() {
        const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
        const markup = draftToHtml(name);
        const settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            customPaging: function (i) {
                return <div className="page_numb"> <h3>{`${i + 1}`}</h3></div>
            }
        };

        const hours = [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]

        const mins = [
            { value: '00', label: '00' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]

        const stamps = [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]

        return (
            <React.Fragment>
                {this.state.loaderFlag ? <Loader /> : ''}
                <div className="right_side_wrapper artistView_wrapper">
                    <ul className="fpg_admin_tab disp_flex small_list_tab">
                        {
                            this.state.data && this.state.data.map((list, index) => {
                                const isRsvpActive = list.label === 'RSVP Form' && this.state.activetab === index;
                                return (
                                    <li className={this.state.activetab === index ? 'active' : ''} onClick={() => this.TabClick(index)}>
                                        <p className="uppercase">
                                            <div style={{ width: isRsvpActive ? 'calc(100% - 58px)' : '100%' }}>
                                                {list.label}
                                            </div>
                                            {isRsvpActive && (
                                                <span className="add_icon d_flex" onClick={(e) => { e.stopPropagation(); this.rsvpFormRef.current && this.rsvpFormRef.current.openAddModal(); }}>
                                                    <PlusIcon />
                                                </span>
                                            )}
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>


                    {!['RSVP Form', 'Website Logos'].includes(this.state.data[this.state.activetab]?.label) && <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <p></p>
                        <p className="update_date">
                            Last Update: {moment(this.state.updatedAt).tz("US/Mountain").format('h')}:{moment(this.state.updatedAt).tz("US/Mountain").format('mm')} {moment(this.state.updatedAt).tz("US/Mountain").format('A')}{' '}
                            MT- {moment.tz(this.state.updatedAt, "US/Mountain").format('MM/DD/YYYY')}{' '}
                            Last Updated By:{" "}  {this.state.updatedBy && this.state.updatedBy.fname} {this.state.updatedBy && this.state.updatedBy.lname}
                        </p>
                    </div>}
                    <div className="ticketing_content  home_content home_page_content">
                        {
                            this.state.activetab === 0 ?
                                <div className="ticketing_wrapper fpg_tabcontent">
                                    <form>
                                        <div className="d_flex">
                                            <div className="header_col">
                                                <div className="sd_content_wrapper">
                                                    <h4 className='mb_15'>Detail Page</h4>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Default Screening Type </label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <DropdownMaster
                                                                    label=""
                                                                    name="defaultScreeningType"
                                                                    options={this.state.locationType}
                                                                    value={this.state.defaultScreeningType}
                                                                    onChange={(e) => this.dropChangeScreeningType(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        <div class="field_row_inner">
                                                            <label class="null">Hide Screenings Section When No Screenings</label>
                                                            <label class="switch">
                                                            <input type="checkbox" checked={this.state.hideWhenNoScreenings} onChange={(e) => this.updateState({hideWhenNoScreenings:!this.state.hideWhenNoScreenings})}/>
                                                            <span class="slider round"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        <div class="field_row_inner">
                                                            <label class="null">Hide Recommendations</label>
                                                            <label class="switch">
                                                            <input type="checkbox" checked={this.state.hideRecommendations} onChange={(e) => this.updateState({hideRecommendations:!this.state.hideRecommendations})}/>
                                                            <span class="slider round"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="sd_content_wrapper">
                                                    {console.log(this.state,"stst")
                                                    }
                                                    <h4 className='mb_15'>Schedule Page</h4>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Default Schedule View </label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <DropdownMaster
                                                                    label=""
                                                                    name="defaultScheduleView"
                                                                    options={this.state.scheduledView}
                                                                    value={this.state.defaultScheduleView}
                                                                    onChange={(e) => this.dropChangeScreeningType(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                                <div className="header_col" style={{ marginLeft: 66 }}>
                                                <div className="sd_content_wrapper">
                                                    <h4 className='mb_15'>Page Settings</h4>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Section </label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <DropdownMaster
                                                                    label=""
                                                                    name="siteSettingsSection"
                                                                    selectedDrop={true}
                                                                    options={this.state.siteSettingsSections}
                                                                    value={this.state.siteSettingsSection}
                                                                    onChange={(e) => this.setState({ siteSettingsSection: e.target.value })}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                {this.state.siteSettingsSection === 'myFavorites' && <div>
                                                    <div className="field_row horizontal_field">
                                                        {/* <Textarea label="Header Subtitle" type="textarea" height="105px" /> */}
                                                        <div className="field_row_inner">
                                                            <label>Header Text </label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.editorStateFestival}
                                                                    onEditorStateChange={this.onEditorStateFestivalChange}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {this.state.siteSettingsSection === 'mySchedule' && <div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                        <label>Banner Text </label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.myScheduleBannerText}
                                                                    onEditorStateChange={this.onEditorStateScheduleChange}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {this.state.siteSettingsSection === 'myViewingRoom' && <div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                        <label>Banner Text </label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.myViewingRoomBannerText}
                                                                    onEditorStateChange={this.onEditorStateChangeViewingRoomBanner}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        {/* <Textarea label="Header Subtitle" type="textarea" height="105px" /> */}
                                                        <div className="field_row_inner">
                                                            <label>Header Text </label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.myViewingRoomHeaderText}
                                                                    onEditorStateChange={this.onEditorStateChangeViewingRoom}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {this.state.siteSettingsSection === 'myWaitlist' && <div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Banner text</label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.myWaitListBannerText}
                                                                    onEditorStateChange={this.onEditorStateChangeWaitlist}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {this.state.siteSettingsSection === 'loginPopup' && <div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Message</label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.fpgLoginMessage}
                                                                    onEditorStateChange={this.onEditorStateChangeFpgLoginMessage}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {this.state.siteSettingsSection === 'preSale' && <div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Enable Banner Text</label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.sioEnableBannerText}
                                                                    onEditorStateChange={this.onEditorStateChangeSioEnableBannerText}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Disable Banner Text</label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.sioDisableBannerText}
                                                                    onEditorStateChange={this.onEditorStateChangeSioDisableBannerText}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {this.state.siteSettingsSection === 'paf' && <div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Banner Text</label>
                                                            <div className="field_input editor_wrapper sd_num_margin">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.pafBannerText}
                                                                    onEditorStateChange={this.onEditorStateChangePafBannerText}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: {
                                                                            inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text_center field_row w_100 buttons_outer home_fixed_footer mb_0">
                                            <button className="uppercase">CANCEL</button>
                                            {this.state.id && <button className="uppercase prev_btn" onClick={(e) => this.previewRecordTalk(e)}>PREVIEW</button>} 
                                            <button className={`uppercase ${(!this.state.id || this.state.isHomeEdited) ? 'active' : ''}`} onClick={(e) => this.submitFilm(e)} disabled={this.state.loaderFlag || (this.state.id && !this.state.isHomeEdited)} type="button">SAVE</button>
                                        </div>
                                    </form>
                                </div>
                                : ''
                        }
                        {
                            this.state.data[this.state.activetab]?.label === 'RSVP Form' ?
                                <RsvpForm ref={this.rsvpFormRef} />
                                : ''
                        }
                        {
                            this.state.data[this.state.activetab]?.label === 'Website Logos' ?
                                <WebsiteLogos />
                                : ''
                        }
                        {
                            this.state.data[this.state.activetab]?.label === 'Header & Footer' ?
                                <div className="ticketing_wrapper fpg_tabcontent">
                                    <form>
                                        <div className="d_flex">
                                            <div className="header_col">
                                                <div className="field_row horizontal_field">
                                                    <TextField
                                                        type="text"
                                                        label="Header Title"
                                                        name="headerTitle"
                                                        value={this.state.headerTitle}
                                                        onChange={this.onInputChange} />
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    {/* <Textarea label="Header Subtitle" type="textarea" height="105px" /> */}
                                                    <div className="field_row_inner">
                                                        <label>Header Subtitle </label>
                                                        <div className="field_input editor_wrapper sd_num_margin">
                                                            <Editor
                                                                wrapperClassName="sd_text_editor"
                                                                editorState={this.state.editorState}
                                                                onEditorStateChange={this.onEditorStateChange}
                                                                toolbar={{
                                                                    blockType: {
                                                                        inDropdown: true,
                                                                        options: ['Normal', 'Blockquote'],
                                                                    },
                                                                    inline: {
                                                                        inDropdown: true,
                                                                        options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                    },
                                                                    list: {
                                                                        inDropdown: true,
                                                                        options: ['unordered', 'ordered'],
                                                                    },
                                                                    textAlign: { inDropdown: true },
                                                                    link: { inDropdown: true },
                                                                    history: { inDropdown: true },
                                                                    options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                                }}
                                                                editorStyle={{ height: '200px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <TextField
                                                        type="text"
                                                        label="CTA Title"
                                                        name="CTATitle"
                                                        value={this.state.CTATitle}
                                                        onChange={this.onInputChange} />
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <TextField
                                                        type="text"
                                                        label="CTA URL"
                                                        name="CTAUrl"
                                                        value={this.state.CTAUrl}
                                                        onChange={this.onInputChange} />
                                                    <span style={{ color: 'red' }}>{this.validator.message('cta URL', this.state.CTAUrl, 'urlValidation')}</span>

                                                </div>
                                                <div className="field_row horizontal_field date_range_with_time">
                                                    <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center">
                                                        <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                            <label>Countdown Date Time</label>
                                                            <div className="form_group_countdown d_flex d_flex_align_center">
                                                               
                                                                <TextField type="text" name="countdownDateTime"
                                                                    value={moment(this.state.countdownDateTime).format("MM/DD/YYYY")}
                                                                    placeholder="mm / dd / yyyy"
                                                                />
                                                                {/* <TextField type="text" name="countDownDate"
                                                                        value={moment(this.state.countdownDateTime).format(
                                                                            "MM/DD/YYYY"
                                                                        )}
                                                                        placeholder="mm / dd / yyyy"
                                                                    /> */}

                                                                <span className="calendar_img">
                                                                    {/* <img src={calendar} alt="calendar icon" title="calendar icon"/>   */}
                                                                    <DatePicker
                                                                        selected={this.state.countdownDateTime}
                                                                        onChange={(e) => this.handleChange(e)}
                                                                        minDate={moment().toDate()}
                                                                        placeholder="mm/dd/yyyy"
                                                                        customInput={
                                                                            <span className="calendar">
                                                                                <CalendarIcon />
                                                                            </span>
                                                                        }
                                                                    />
                                                                </span>

                                                                <Select
                                                                    options={hours}
                                                                    value={this.state.hours}
                                                                    name='hours'
                                                                    placeholder="7"
                                                                    onChange={(e) => this.handleTimeHours(e)} />
                                                                <Select
                                                                    options={mins}
                                                                    value={this.state.mins}
                                                                    name='mins'
                                                                    placeholder="30"
                                                                    onChange={(e) => this.handleTimeMins(e)} />
                                                                <Select
                                                                    options={stamps}
                                                                    value={this.state.stamps}
                                                                    name='stamps'
                                                                    placeholder="AM"
                                                                    onChange={(e) => this.handleTimeStamps(e)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <Textarea
                                                        label="Countdown Text"
                                                        type="text"
                                                        height="51px"
                                                        name="countdownText"
                                                        value={this.state.countdownText}
                                                        onChange={this.onInputChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text_center field_row w_100 buttons_outer mb_0">
                                            <button className="uppercase">CANCEL</button>
                                            {this.state.id && <button className="uppercase prev_btn" onClick={(e) => this.previewRecordTalk(e)}>PREVIEW</button>} 
                                            <button className={`uppercase ${(!this.state.id || this.state.isHomeEdited) ? 'active' : ''}`} onClick={(e) => this.submitFilm(e)} disabled={this.state.loaderFlag || (this.state.id && !this.state.isHomeEdited)} type="button">SAVE</button>
                                        </div>
                                    </form>
                                </div>
                                : ''
                        }
                        {
                            this.state.data[this.state.activetab]?.label === 'carousel' ?
                                <>
                                    <div className="home_carousel fpg_tabcontent">
                                        <div className="section_title text_center slider_pagination">
                                            <p className="uppercase">Select a section</p>
                                        </div>
                                        <div className="select_style_wrap_outer">
                                            <Carousal />
                                        </div>
                                    </div>

                                </>
                                :

                                ""
                        }
                    </div>
                    {this.state.messageModal &&
                        <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
                    }
                    {this.state.errorPopup ?
                        <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                        />
                        : ''
                    }
                </div>
            </React.Fragment>
        )
    }
}
